import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Tabs, Tab, Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const Navigation = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const getTabValue = () => {
    if (location.pathname === '/') return 0;
    if (location.pathname === '/upload') return 1;
    if (location.pathname === '/gallery') return 2;
    if (location.pathname === '/calendar') return 3;
    return -1; // For other routes like /date/:date
  };

  return (
    <AppBar 
      position="absolute" 
      sx={{ 
        backgroundColor: 'transparent', 
        boxShadow: 'none',
        color: isHomePage ? 'inherit' : 'text.primary',
      }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          <Tabs 
            value={getTabValue()} 
            textColor="inherit" 
            indicatorColor="secondary"
            sx={{
              '& .MuiTab-root': {
                minWidth: 64,
                color: isHomePage ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)',
                '&.Mui-selected': {
                  color: isHomePage ? 'white' : 'primary.main',
                },
              },
            }}
          >
            <Tab
              icon={<HomeIcon sx={{ fontSize: 28, color: 'inherit' }} />}
              component={Link}
              to="/"
            />
            <Tab
              icon={<PhotoCameraIcon sx={{ fontSize: 28, color: 'inherit' }} />}
              component={Link}
              to="/upload"
            />
            <Tab
              icon={<PhotoLibraryIcon sx={{ fontSize: 28, color: 'inherit' }} />}
              component={Link}
              to="/gallery"
            />
            <Tab
              icon={<CalendarMonthIcon sx={{ fontSize: 28, color: 'inherit' }} />}
              component={Link}
              to="/calendar"
            />
          </Tabs>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;

